<template>
  <el-row class="main-container">
    <el-col
      :sm="6"
      :lg="5"
      :xl="4"
      class="campaign-main-list">
      <el-row>
        <el-col class="main-header">
          <h1>Campañas</h1>
          <el-button
            circle
            @click="addCampaign">
            <i class="icon-plus"/>
          </el-button>
        </el-col>
      </el-row>
      <el-row
        v-if="profile.role === 'superadmin'"
        class="campaign-options">
        <el-col>
          <el-button
            :class="{active: $route.name === 'campaigns-list-approve'}"
            @click="$router.push({ name: 'campaigns-list-approve' })">
            <i class="icon-thumbs-up"/>
            <span>
              Aprobación de campañas
            </span>
          </el-button>
        </el-col>
      </el-row>
      <el-row
        v-if="profile.role === 'gerente_dealer'"
        class="campaign-options">
        <el-col>
          <el-button
            :class="{active: $route.name === 'campaigns-pre-approve'}"
            @click="$router.push({ name: 'campaigns-pre-approve' })">
            <i class="icon-thumbs-up"/>
            <span>
              Pre-aprobación de campañas
            </span>
          </el-button>
        </el-col>
      </el-row>
      <el-row class="campaign-options">
        <el-col>
          <el-button
            :class="{active: $route.name === 'campaigns-list-recent'}"
            @click="$router.push({ name: 'campaigns-list-recent' })">
            <i class="icon-clock"/>
            <span>
              Recientes
            </span>
          </el-button>
        </el-col>
      </el-row>
      <el-row class="campaign-options">
        <el-col>
          <el-button
            :class="{active: $route.name === 'campaigns-list'}"
            @click="$router.push({ name: 'campaigns-list' })">
            <i class="icon-trending-up"/>
            <span>
              Todas
            </span>
          </el-button>
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :sm="18"
      :lg="19"
      :xl="20"
      class="container-section-main">
      <router-view/>
    </el-col>
    <campaign-create-view
      v-if="showCampaignPanel"
      @closeCampaign="closeCampaign"/>
  </el-row>
</template>
<script>
import CampaignCreateView from '@/views/app/campaigns/campaign-create-view'
export default {
  name: 'CampaignsView',
  components: {
    CampaignCreateView
  },
  data () {
    return {
      showCampaignPanel: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    addCampaign () {
      this.showCampaignPanel = true
      this.$store.dispatch('app/toggleCampaignPanel')
    },
    closeCampaign (value) {
      if (value) {
        this.showCampaignPanel = false
        this.$store.dispatch('app/toggleCampaignPanel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .campaign-main-list{
      height: calc(100% - 60px);
      padding: 0 15px;
      border-right: 1px solid $border-primary;
      position: relative;
      overflow: auto;
      background-color: #ffffff;
      .main-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          @include font-primary(21px, regular);
          color: #707070;
        }
        .el-button {
          background-color: $primary;
          border: none;
          color: #ffffff;
          box-shadow: 0 3px 6px 0 rgba(#E7120E, 0.5);
        }
      }
      .campaign-options{
        margin: 10px -15px;
        height: 50px;
        .el-button{
          width: 100%;
          height: 50px;
          border-radius: 0;
          border: none;
          background-color: #ffffff;
          @include font-lato(13px, bold);
          display: flex;
          justify-content: flex-start;
          i{
            color: $icon;
          }
          span{
            color: $items-primary;
          }
          &:hover,
          &:focus {
            background-color: #e8e6e6;
          }
        }
        .active {
         background-color: #e8e6e6;
        }
      }
    }
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      overflow: auto;
      margin-right: -50px;
      background-color: $secondary;
      padding: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/campaigns/campaigns-view.vue